import { FC, PropsWithChildren } from 'react';

const UnProtectedPage: FC<PropsWithChildren> = ({ children }) => {
  return <div className="flex flex-col">{children}</div>;
};

export default UnProtectedPage;
